import { Box, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Variant } from '@mui/material/styles/createTypography';
import React from 'react';

const useStyles = makeStyles((theme: any) => ({
  text: {
    color: theme.palette.primary.darker,
    fontWeight: 400,
    background: theme.palette.background.default,
    opacity: 1
  },
  textShadow: { textShadow: `0.25px 0.5px ${theme.palette.text.light}` },
  plainWrapper: {
    height: 42,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
  },
  plainText: {
    display: '-webkit-box',
    '-webkit-line-clamp': 2,
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
    width: '100%',
    lineHeight: 1.3,
    fontVariantNumeric: 'tabular-nums',
    padding: '0 8px',
  },
}));

type CellTextType = {
  data?: string,
  position?: 'center' | 'left' | 'right',
  colorText?: string | undefined,
  shadow?: boolean,
  backgroundColor?: string | undefined,
  variant?: 'inherit' | Variant | undefined,
  plain?: boolean
};

const CellText = ({
  data = '',
  position = 'center',
  colorText,
  shadow = false,
  backgroundColor,
  variant,
  plain = false
}: CellTextType) => {
  const { text, textShadow, plainWrapper, plainText } = useStyles();
  return (
    <Box className={plain ? plainWrapper : undefined} style={plain ? undefined : { width: '100%' }}>
      <Typography
        variant={variant}
        title={plain ? data : undefined}
        style={{
          textAlign: position || 'center',
          color: colorText,
          background: plain ? 'transparent' : backgroundColor,
          padding: plain ? undefined : '5px',
        }}
        className={`${plain ? plainText : text} ${shadow && textShadow}`}
      >
        {data}
      </Typography>
    </Box>
  );
};

export default CellText;
